/**
 * Chip — Selectable tag/filter element
 *
 * Variants:
 *   - selected: true/false
 *   - size: sm, md
 *
 * Pass `selected` to both Chip and ChipText to match colors.
 */
import { styled, XStack, Text as TamaguiText, type GetProps } from 'tamagui'

const ChipFrame = styled(XStack, {
  name: 'Chip',
  role: 'button',
  ai: 'center',
  jc: 'center',
  br: '$xl',
  bw: 2,
  bc: '$borderColor',
  bg: '$backgroundCard',
  cursor: 'pointer',
  pressStyle: { opacity: 0.7, scale: 0.97 },
  hoverStyle: { opacity: 0.85 },

  variants: {
    selected: {
      true: {
        bg: '$colorPrimary',
        bc: '$colorPrimary',
      },
    },

    size: {
      sm: {
        px: '$sm',
        py: '$xs',
      },
      md: {
        px: '$md',
        py: 10,
      },
    },
  } as const,

  defaultVariants: {
    size: 'md',
  },
})

export const Chip = ChipFrame.styleable((props, ref) => (
  <ChipFrame
    ref={ref}
    transition="quick"
    animateOnly={['opacity', 'transform', 'background-color']}
    {...props}
  />
))

export const ChipText = styled(TamaguiText, {
  name: 'ChipText',
  fontFamily: '$body',
  fontSize: 14,
  fontWeight: '600',
  color: '$color',

  variants: {
    selected: {
      true: {
        color: '$colorInverse',
      },
    },
    size: {
      sm: { fontSize: 12 },
      md: { fontSize: 14 },
    },
  } as const,
})
